import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "login-wrapper"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginBackground = _resolveComponent("LoginBackground")!
  const _component_LoginBox = _resolveComponent("LoginBox")!

  return (_ctx.containerShow)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_LoginBackground, {
          baseRatio: _ctx.baseRatio,
          zoomRatio: _ctx.zoomRatio
        }, null, 8, ["baseRatio", "zoomRatio"]),
        _createVNode(_component_LoginBox, {
          class: _normalizeClass(["login-main-container", { 'login-main-center': _ctx.zoomRatio < 0.66 }])
        }, null, 8, ["class"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2))
}